import PasswordRecoveryUpdate from "./PasswordRecoveryUpdate";

export default PasswordRecoveryUpdate;
